export const BACKEND_API_BASE_URL =
  process.env.REACT_APP_BACKEND_API_BASE_URL || "https://backend.rickywin.com";

// Water-device (PDH_LAB_WIFI) sampling override bounds for the run-start
// form - mirrors padihat-firmware-v0.3's own firmware/include/config.h
// (DISTANCE_SAMPLES_MIN/MAX_DISTANCE_SAMPLES) and the backend's
// greenhouse_start_run validation (padihat-backend/padihat/greenhouse_views.py),
// so an invalid value is caught client-side before the request round-trip.
export const WATER_SAMPLE_SECONDS_MIN = 0.25; // 250ms
export const WATER_SAMPLE_SECONDS_MAX = 60;
export const WATER_DISTANCE_SAMPLES_MIN = 5;
export const WATER_DISTANCE_SAMPLES_MAX = 200;
// Worst-case ms per ultrasonic echo attempt (25ms spacing + up to 30ms+30ms
// of echo timeouts) - used only for the soft cadence warning below, not a
// hard rule (firmware/backend don't block on it either).
export const WATER_DISTANCE_SAMPLE_WORST_MS = 85;
